export default class AppConfig {
    static setConfig(value) {
        this._config = value;
    }
    static getConfig() {
        return this._config;
    }
    constructor() { }
}
